import type { AuthStoreStateRepository } from '@/shared/contracts/authStoreState.repository';
import type { AuthUserEntityStore } from '@/shared/models/authStore.model';
import { authStoreAccessRepository } from './authStoreAccess.repository';

/**
 * Implementación concreta para acceso al estado de auth store
 * Wrappea repositorio centralizado detrás de una interfaz para DI
 * Cumple con SRP: solo acceso al estado del auth store
 * MEJORADO: Usa repositorio centralizado para eliminar duplicación
 */
class AuthStoreStateApiRepository implements AuthStoreStateRepository {
  getCurrentAuthState(): AuthUserEntityStore {
    return authStoreAccessRepository.getCurrentAuthState();
  }
}

export const authStoreStateApiRepository = new AuthStoreStateApiRepository();
